export const rentalYield = 0.0985;
export const tenPointFivePercentRentalYield = 0.105;
export const tenPointTwentyFivePercentRentalYield = 0.1025;
export const tenPercentRentalYield = 0.1;
